import { ConfigProps } from '@config/types'

const config = ({ staticAssetPageUrl, staticPageUrlSuffix }: ConfigProps) => ({
  facebookAppId: '198633050385',
  facebookStaticPageUrl: `${staticAssetPageUrl}/facebook${staticPageUrlSuffix}?url=`,
  twitterEmbedStaticPageUrl: `${staticAssetPageUrl}/twitter${staticPageUrlSuffix}?url=`,
  instagramEmbedStaticPageUrl: `${staticAssetPageUrl}/instagram${staticPageUrlSuffix}?url=`,
  share: {
    utmMedium: 'social',
    utmCampaign: 'share-button',
    types: {
      facebook: {
        utmSource: 'facebook',
        iconName: 'facebook-plain',
      },
      twitter: {
        utmSource: 'twitter',
        iconName: 'twitter-plain',
      },
      whatsapp: {
        utmSource: 'whatsapp',
        iconName: 'whatsapp-plain',
      },
      mail: {
        utmSource: 'transactional',
        utmMedium: 'email',
        iconName: 'mail-plain',
      },
      copy: {
        utmSource: 'copy-to-clipboard',
        iconName: 'copy-plain',
      },
      print: {
        iconName: 'print-plain',
      },
    },
  },
})

export type configType = ReturnType<typeof config>
export default config
